// extracted by mini-css-extract-plugin
export default {"InfoTooltipInfo":"styles_InfoTooltipInfo__pUiDo","InfoTooltip":"styles_InfoTooltip__EZ7ZR"};